<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" v-if="showGameAndPlatform">
        <v-icon left color="primary" v-if="platformIcon">{{ platformIcon }}</v-icon>
        <v-icon left v-if="gameIcon">{{ gameIcon }}</v-icon>
        <span class="text--secondary">{{ gameName }}</span>
      </v-col>
      <v-col cols="12" sm="6" v-if="showGameAndPlatform && this.game.mode">
        <v-icon left>{{ getGameModeIcon(this.game.mode) }}</v-icon>
        <span class="text--secondary">{{ getGameModeLabelByGame(this.game) }}</span>
      </v-col>
      <v-col cols="12" v-if="showGameState && game.state == 'created'">
        <info-block>
          {{$t('gameInfo.currently-in-preparation')}}
        </info-block>
      </v-col>
      <v-col cols="12" v-if="showGameState && game.state == 'checkin'">
        <info-block>
          {{$t('gameInfo.currently-checkin-phase')}}
        </info-block>
      </v-col>
      <v-col cols="12" v-if="showGameState && game.checkInAt && (game.state == 'created')">
        <info-block>
          {{$t('gameInfo.planned-checkin-time-from')}}:<br/>
          {{$datefns.formatRelativeWithTime(game.checkInAt)}}
        </info-block>
      </v-col>
      <v-col cols="12" v-if="showGameState && game.startsAt && (game.state == 'created' || game.state == 'checkin')">
        <info-block>
          {{$t('gameInfo.planned-start-time')}}:<br/>
          {{$datefns.formatRelativeWithTime(game.startsAt)}}
        </info-block>
      </v-col>
      <v-col cols="12" v-if="showGameState && game.manualNextRound && (game.state == 'active')">
        <info-block>
          {{$t('gameInfo.manually-game-rounds')}}
        </info-block>
      </v-col>
      <v-col cols="12" v-if="game.prizes && game.prizes.length > 0">
        <prizes-summary-widget :prizes="game.prizes"></prizes-summary-widget>
      </v-col>
      <v-col cols="12" v-if="game.pot !== null">
        <span>{{$t('common.pot')}}:</span><pot-widget :amount="game.pot"/>
      </v-col>
      <v-col cols="12" v-if="game.participationCoinFee > 0">
        <span>{{$t('common.participation-fee')}}:</span><coins-widget :amount="game.participationCoinFee"/>
      </v-col>
      <v-col cols="12" v-if="showDescription && game.description">
        <span style="white-space: pre-wrap;">{{game.description}}</span>
      </v-col>
      <v-col cols="12" v-if="showLegal">
        <game-legal :userCupNotice="game.isPublicUserCup"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GameLegal from "@/components/content/GameLegal";
import InfoBlock from "@/widgets/InfoBlock"
import PrizesSummaryWidget from '@/widgets/prize/PrizesSummaryWidget.vue';
import CoinsWidget from './CoinsWidget.vue';
import PotWidget from './PotWidget.vue';
import gameMixin from "@/mixins/gameMixin";
import gameModeMixin from "@/mixins/gameModeMixin";
import platformMixin from "@/mixins/platformMixins";

export default {
  name: "GameInfo",
  components: {
    GameLegal,
    InfoBlock,
    PrizesSummaryWidget,
    CoinsWidget,
    PotWidget,
  },
  mixins: [gameMixin, gameModeMixin, platformMixin],
  props: {
    game: {
      type: Object,
      required: true
    },
    showGameAndPlatform: {
      type: Boolean,
      default: false
    },
    showGameState: {
      type: Boolean,
      default: true
    },
    showDescription: {
      type: Boolean,
      default: true
    },
    showLegal: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    platformIcon: function() {
      return this.getPlatformIcon(this.game.platform);
    },
    gameIcon: function() {
      let game = this.getGameByCode(this.game.game);
      return game ? game.mdi_icon : undefined;
    },
    gameName: function() {
      let game = this.getGameByCode(this.game.game);
      return game ? game.name : this.game.game;
    }
  },
  data: function() {
    return {};
  }
};
</script>
